import axios from "axios";

let contactId = null;
let domain = window.ahwa.site_url;
console.log(domain)

const apiService = {
  storeRecord(data) {
    /**
     * If we already have the user
     */
    if (contactId !== null) {
      data.contact_id = contactId;
    }

    /**
     * Send the data to our endpoint
     */
    axios
      .post(`${domain}/wp-json/booking/v1/sync-lead`, data)
      .then(response => {
        if (200 === response.status) {
          console.log(response);
        } else {
          console.log(`Wrong Status`);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};

export default apiService;
